var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',[_c('ul',{staticClass:"app-header-nav"},_vm._l((_vm.list),function(item){return _c('li',{key:item.id,class:{ 'active':_vm.$route.query.id == item.id },on:{"click":function($event){return _vm.clickFn(item)}}},[_c('a',{attrs:{"href":item.url}},[_vm._v(_vm._s(item.name))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }